import React from 'react';
import * as S from './styles';
import { IconProps } from '@prisjakt/ui/icon/types';

interface IExpandButton {
  expanded: boolean;
  onClick: () => void;
  title?: string;
  featured: boolean;
  renderIcon?: (color: IconProps['color']) => React.ReactNode;
}

export const ExpandButton: React.FC<IExpandButton> = ({
  expanded,
  onClick,
  title,
  featured,
  renderIcon,
}) => {
  const color = featured ? 'maybeBlue700' : 'base500';

  return (
    <S.ExpandButton
      type="button"
      aria-label={title}
      onClick={onClick}
      expanded={expanded}
      data-test="ExpandButton"
    >
      {renderIcon && renderIcon(color)}
    </S.ExpandButton>
  );
};
